<template>
  <v-textarea
    v-if="!$attrs.disabled"
    :value="value"
    @input="(value) => $emit('input', value)"
    v-bind="$attrs"
    :prepend-inner-icon="i != 0 ? '$curvedArrowLeftIcon' : 'far fa-clone'"
    :append-icon="i == 0 ? '' : ''"
    @click:prepend-inner="$emit('updateRowsExplanation', i)"
    class="row-textarea rounded-lg"
  />
  <div v-else v-tooltip="truncate ? value : undefined">
    <v-textarea class="rounded-lg" :value="limitedValue" v-bind="$attrs" disabled ref="textarea" />
  </div>
</template>

<script>
export default {
  name: "MTextarea",
  props: {
    value: {},
    i: {
      required: true,
    },
    truncate: {
      default: true,
    },
  },
  data() {
    return {
      width: 80,
    };
  },
  computed: {
    limitedValue() {
      if (!this.truncate) return this.value;
      if (this.value) {
        return this.value.substr(0, this.width / 2.2) + "...";
      }
      return this.value;
    },
  },
  mounted() {
    if (this.$refs.textarea) {
    }
  },
};
</script>

<style lang="scss">
.row-textarea {
  min-width: 140px;
}
</style>
